import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-array-item-deletion',
  templateUrl: './warning-array-item-deletion.component.html',
  styleUrls: ['./warning-array-item-deletion.component.scss'],
  standalone: false,
})
export class WarningArrayItemDeletionComponent implements OnInit {

  @Input() objectDefinition: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
